import { render } from "./FriendCard.vue?vue&type=template&id=bc11c186&scoped=true"
import script from "./FriendCard.vue?vue&type=script&lang=js"
export * from "./FriendCard.vue?vue&type=script&lang=js"

import "./FriendCard.vue?vue&type=style&index=0&id=bc11c186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc11c186"]])

export default __exports__